import React from "react";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import useRudderStackAnalytics from "../../config/useRudderAnalytics";
import { useNavigate, useParams } from "react-router-dom";
import { getListReport, resetReportState } from "../../reducers/reportReducer";
import { resetRunState } from "../../reducers/runReducer";
export default function ListReport(){
    const useRudderAnalytics=useRudderStackAnalytics();
    const dispatch=useDispatch();    
    const navigate=useNavigate();
    const driverId=useSelector(state=>state.driver.entities.currDriver?.driverId);
    const {id}=useParams();
    const handleToggle=(event)=>{
        navigate("/"+id+"/haccp/report/"+event.currentTarget.value)
    }
    const reportList=useSelector(state=>state.report.entities.reportList);
    const reportListElement=reportList && reportList.length>0?[...reportList].sort((a,b)=>new Date(b.date)- new Date(a.date)).map((e,id)=><Button className="listReport" onClick={handleToggle} key={id} value={e.date} variant="contained" >{e.run+" || "+dayjs(e.date).format("DD/MM/YYYY HH:mm A")}</Button>):<h3 style={{textAlign:"center"}}>You don't have any HACCP report available right now.</h3>
    React.useEffect(()=>{
        dispatch(resetReportState())
        dispatch(resetRunState())
        dispatch(getListReport({driverId:id}))
    },[dispatch, id])
    React.useEffect(()=>{
        if(useRudderAnalytics && driverId){
            useRudderAnalytics.page("List Vehicle Temp")
        }
    },[useRudderAnalytics, driverId])
    return (
        <>
            <div style={{display:"flex", justifyContent:"center", alignItems:"center", gap:"10px", flexDirection:"column", height:"100%", overflow:"hidden", paddingBottom:"20px"}}>
               {reportListElement}
            </div>
        </>
    )
}